import React, { useState } from 'react';
import './RoiCalculatorForm.css';

const RoiCalculatorForm = ({ onCalculateRoi, setShowResults }) => {
  // State for form values with default values from instructions
  const [formData, setFormData] = useState({
    // Marketing information
    firstName: '',
    lastName: '',
    company: '',
    position: '',
    email: '',
    
    // Original form data
    pdgmCensus: 500, // Default from instructions
    clinicianHourlyRate: 45, // Default from instructions
    cScorePercentage: 38, // Industry average: 38%
    emr: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onCalculateRoi) {
      onCalculateRoi(formData);
    }
    
    // Explicitly show results section after submission
    if (setShowResults) {
      setShowResults(true);
    }
    
    // Scroll to results section
    setTimeout(() => {
      const resultsElement = document.querySelector('.results-display');
      if (resultsElement) {
        resultsElement.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div className="roi-calculator-form">
      <h2>ROI Calculator</h2>
      
      <form onSubmit={handleSubmit}>
        {/* Practice Information Section */}
        <div className="form-section">
          <h3>Practice Information</h3>
          
          <div className="form-group">
            <label htmlFor="pdgmCensus">Home Health PDGM Census (ADC)</label>
            <input 
              type="number" 
              id="pdgmCensus" 
              name="pdgmCensus" 
              value={formData.pdgmCensus} 
              onChange={handleChange} 
              required 
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="clinicianHourlyRate">Average Clinician Hourly Rate ($)</label>
            <input 
              type="number" 
              id="clinicianHourlyRate" 
              name="clinicianHourlyRate" 
              value={formData.clinicianHourlyRate} 
              onChange={handleChange} 
              required 
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="cScorePercentage">Percentage of Episodes with C Functional Score (%)</label>
            <input 
              type="number" 
              id="cScorePercentage" 
              name="cScorePercentage" 
              value={formData.cScorePercentage} 
              onChange={handleChange} 
              required 
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="emr">Current EMR System</label>
            <input 
              type="text" 
              id="emr" 
              name="emr" 
              value={formData.emr} 
              onChange={handleChange} 
            />
          </div>
        </div>

        {/* Contact Information Section */}
        <div className="form-section">
          <h3>Contact Information</h3>
          
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="firstName">First Name</label>
              <input 
                type="text" 
                id="firstName" 
                name="firstName" 
                value={formData.firstName} 
                onChange={handleChange}
                required 
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="lastName">Last Name</label>
              <input 
                type="text" 
                id="lastName" 
                name="lastName" 
                value={formData.lastName} 
                onChange={handleChange}
                required 
              />
            </div>
          </div>
          
          <div className="form-group">
            <label htmlFor="company">Company</label>
            <input 
                type="text" 
                id="company" 
                name="company" 
                value={formData.company} 
                onChange={handleChange}
                required 
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="position">Position</label>
            <input 
                type="text" 
                id="position" 
                name="position" 
                value={formData.position} 
                onChange={handleChange}
                required 
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input 
                type="email" 
                id="email" 
                name="email" 
                value={formData.email} 
                onChange={handleChange}
                required 
            />
          </div>
        </div>
        
        <button type="submit" className="calculate-button">Send Me My Report</button>
      </form>
    </div>
  );
};

export default RoiCalculatorForm;
